import { render, staticRenderFns } from "./logoUpload.vue?vue&type=template&id=47de59a1&scoped=true&"
import script from "./logoUpload.vue?vue&type=script&lang=js&"
export * from "./logoUpload.vue?vue&type=script&lang=js&"
import style0 from "./logoUpload.vue?vue&type=style&index=0&id=47de59a1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47de59a1",
  null
  
)

export default component.exports